
  <div class="min-h-screen app-container">
    <DefaultHeader />
    <main class="w-full">
      <RouterView />
    </main>
  </div>
